import { FC } from 'react'
import { UserSquare } from '@phosphor-icons/react'

import { IconPropsType } from '~/src/components/generic/PhosphorIcons/types'

const Icon: FC<IconPropsType> = ({ color, size, weight, mirrored }) => (
  <UserSquare color={color} size={size} weight={weight} mirrored={mirrored} />
)

export default Icon
